import React, { FC, Fragment } from 'react';
import moment from 'moment';
import { Grid, Link, Typography } from '@material-ui/core';

import { useContent } from 'hooks';
import { Separator } from 'components';
import { generateLink } from 'Links';

import { isUrl } from 'features/content/helpers';
import { Groups } from './index';

const Details: FC = () => {
  const content = useContent();
  const { content_id, publish_at, content_object } = content;

  const hasUrl = isUrl(content);

  return (
    <Grid container alignItems="center">
      {hasUrl && (
        <Fragment>
          <Link target="_blank" href={content_object?.url}>
            <Typography>{content_object?.url_metadata?.provider_display}</Typography>
          </Link>
          <Separator color="textSecondary" />
        </Fragment>
      )}
      <Groups />
      <Link component={generateLink(`/content/${content_id}`)}>
        <Typography color="textSecondary">{moment.unix(publish_at).fromNow()}</Typography>
      </Link>
    </Grid>
  );
};

export default Details;
